import { render, staticRenderFns } from "./SortList.vue?vue&type=template&id=466bd82e&scoped=true"
import script from "./SortList.vue?vue&type=script&lang=js"
export * from "./SortList.vue?vue&type=script&lang=js"
import style0 from "./SortList.vue?vue&type=style&index=0&id=466bd82e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466bd82e",
  null
  
)

export default component.exports